<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<qiujing v-if="activeTab == '1'" ref="qiujing"></qiujing>
			<zhujing v-if="activeTab == '2'" ref="zhujing"></zhujing>
		</topTab>
	</div>
</template>

<script>
import qiujing from "./qiujing.vue";
import zhujing from "./zhujing.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "球镜管理"
				},
				{
					key: "2",
					value: "柱镜管理"
				}
			]
		};
	},
	// 注册组件
	components: {
		qiujing,
		zhujing
	},
	created() {},
	computed: {},
	methods: {
		changePages(tab) {
			this.activeTab = tab;
		}
	}
};
</script>

<style scoped>
.one_1 {
	background-color: rgb(253, 175, 5);
	display: block;
}
</style>
